function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8079"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7983"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 171",
  cx: 35,
  cy: 35,
  r: 35,
  fill: "#e8f6f4"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon material-account-balance",
  d: "M21.489 32.082v12.507h5.234V32.082zm10.468 0v12.507h5.234V32.082zM18 53.523h33.15v-5.36H18zm24.426-21.441v12.507h5.234V32.082zM34.575 16L18 24.934v3.574h33.15v-3.574L34.575 16z",
  fill: "#a1dbd3"
}));
var SvgBankCircle = function SvgBankCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 70"
  }, props), _ref);
};
export default SvgBankCircle;